import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=6c22bbc0&"
import script from "./Projects.ts?vue&type=script&lang=ts&"
export * from "./Projects.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports